<template>
  <v-breadcrumbs v-if="breadcrumbs.length > 0" :icon="smAndUp ?'mdi-home' : null" color="text-color" :items="breadcrumbs">
    <template #item="{ item }">
      <v-breadcrumbs-item
        :disabled="item.disabled"
        :href="item.href"
        :to="item.to"
        :exact="item.exact"
        class="text-body-2 font-weight-medium">
        <span v-if="!smAndUp && item.title.toLowerCase() === 'dashboard'">
          <v-icon icon="mdi-home" size="22.5" />
        </span>
        <span v-else>
          {{ item.title }}
        </span>
      </v-breadcrumbs-item>
    </template>
    <template #divider>
      <v-icon icon="mdi-chevron-right" />
    </template>
  </v-breadcrumbs>
  <VBreadcrumbs v-else color="text-color" :items="defaultBreadcrumbs">
    <template #divider>
      <v-icon  icon="mdi-chevron-right" />
    </template>
  </VBreadcrumbs>
</template>

<script setup>
import { useAppStore } from '@/stores/app';
import { computed } from 'vue';
import { useDisplay } from 'vuetify/lib/composables/display';
const { smAndUp } = useDisplay();

const app = useAppStore();

const breadcrumbs = computed(() => app.getBreadcrumbs);

const defaultBreadcrumbs = computed(() => [
  {
    title: app.getAppTitle,
    disabled: true,
    href: '/',
  },
]);
</script>